import Storage from '../protocol/Storage';
import System from './System';
//@flow
export default class Theme {
  static LIGHT: Theme;
  static DARK: Theme;

  _name: string;

  constructor(name: string, theme: Object) {
    this._name = name;
  }

  isLight(): boolean {
    return this === Theme.LIGHT;
  }

  isDark(): boolean {
    return this === Theme.DARK;
  }

  static onLight(theme: Theme): Promise<void> {
    return new Promise((success, failure) => {
      if (theme.isLight()) {
        success();
      } else {
        failure();
      }
    });
  }

  static onDark(theme: Theme): Promise<void> {
    return new Promise((success, failure) => {
      if (theme.isDark()) {
        success();
      } else {
        failure();
      }
    });
  }

  getName(): string {
    return this._name;
  }

  toString(): string {
    return this._name;
  }

  static getTheme(): Theme {
    const currentTheme = Storage.get('THEME');
    if (!currentTheme) return null;
    const theme = currentTheme === Theme.LIGHT.getName() ? Theme.LIGHT : Theme.DARK;
    return theme;
  }

  static setTheme(theme: Theme): void {
    Storage.set('THEME', theme.getName());
    System.getInstance().put(System.THEME_KEY, theme);
  }
}

Theme.LIGHT = new Theme('light');
Theme.DARK = new Theme('dark');
